import { useState } from "react";
import Button from "../components/Button";
import SGLogoIcon from "/public/images/icons/sgLogoIconNoFill.svg?react";
import TextInput from "../components/TextInput";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
//import { useDrawerContext } from '../context/drawerContext';
import * as Sentry from "@sentry/react";
import { LogErrors } from "../utils/LogErrors";
import { useUserContext } from "../context/userContext";

export default function PasswordReset() {
  // Your code here
  const [errors, setErrors] = useState({});
  // const { setOpen, setDrawerContent } = useDrawerContext();
  const navigate = useNavigate();
  const { user, logout, updateTokens } = useUserContext();

  const resetPass = async (event) => {
    event.preventDefault();
    setErrors({});
    const newDetails = new FormData(event.currentTarget);
    const email = newDetails.get("email");
  
    return await Sentry.startSpan({ name: "Reset Password", op: "http.request" }, async (span) => {
      try {
        const url = import.meta.env.VITE_API_URL + `Users/SetUserRequireOTP?email=${email}`;
        span.setAttribute("http.url", url);
        span.setAttribute("user_email", email);
  
        const req = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (req.status === 401) {
          const errorMessage = "Email is incorrect. Please try again.";
          setErrors({ email: errorMessage });
          Sentry.captureMessage(errorMessage, "warning");
        } else if (req.status === 200) {
          navigate("/login", { state: { reset: true } });
        }
  
        span.setStatus(req.status === 200 ? "ok" : "error");
      } catch (error) {
        Sentry.captureException(error, { extra: { user_email: email } });
        LogErrors(user, logout, updateTokens, "Error resetting password: " + error);
      }
    });
  };

  return (
    <>
      <div className="flex flex-col gap-4 p-6">
        <SGLogoIcon style={{ fill: "black" }} className="w-[40px] h-[40px]" />
        <h1 className="text-[40px] mb-5">
          Reset your <br />
          Password
        </h1>
        <form className="flex flex-col gap-4" onSubmit={resetPass}>
          <TextInput
            key={"email"}
            error={errors.email}
            name="email"
            label="Email"
            placeholder="Enter Email"
          />
          <Button submit>Reset</Button>
        </form>
        <p className="text-sportsDarkGrey text-center">
          Don&apos;t need to reset your password?{" "}
        </p>
        <Link className="flex flex-col justify-stretch" to={"/login"}>
          {" "}
          <Button status="nobg" variant="tertiary">
            Go Back
          </Button>{" "}
        </Link>
      </div>
    </>
  );
}
